import React from 'react';

interface ILoaderProviderProps {
  children: React.ReactNode;
}

const Context = React.createContext<{
  toggleLoader: (show: boolean) => void;
  showLoader: boolean;
}>({
  toggleLoader: () => {},
  showLoader: false
});

export const LoaderProvider = ({ children }: ILoaderProviderProps) => {
  const [showLoader, setShowLoader] = React.useState<boolean>(false);

  const toggleLoader = (show: boolean) => {
    setShowLoader(show);
  };

  const value = React.useMemo(() => ({ toggleLoader, showLoader }), [showLoader]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

const useLoader = () => {
  const context = React.useContext(Context);
  if (!context) {
    throw new Error('useLoader() can only be used within LoaderProvider');
  }
  return context;
};

export default useLoader;
